import { render, staticRenderFns } from "./ccDetail.vue?vue&type=template&id=115533b3&scoped=true"
import script from "./ccDetail.vue?vue&type=script&lang=js"
export * from "./ccDetail.vue?vue&type=script&lang=js"
import style0 from "./mixins/detailLayout.scss?vue&type=style&index=0&id=115533b3&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115533b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115533b3')) {
      api.createRecord('115533b3', component.options)
    } else {
      api.reload('115533b3', component.options)
    }
    module.hot.accept("./ccDetail.vue?vue&type=template&id=115533b3&scoped=true", function () {
      api.rerender('115533b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/approvalList/ccDetail.vue"
export default component.exports